import {
    TprmRequirementType,
    TprmRequirementTypeMultiInstance,
} from '@evidentid/tprm-portal-lib/models/entity-details';

export function flattenSingleOrMultiRequirementType(
    requirementType: TprmRequirementType | TprmRequirementTypeMultiInstance,
): TprmRequirementType {
    if (typeof requirementType === 'object' && 'requirement' in requirementType) {
        return requirementType.requirement;
    }
    return requirementType;
}
